if (!customElements.get('offer-coupon')) {
  customElements.define(
    'offer-coupon',
    class OfferCoupon extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.label = this.querySelector('[data-label]');
        this.done = this.querySelector('[data-done]');
        this.button.addEventListener('click', () => this.copy());
      }

      async copy() {
        const code = this.dataset.code;
        try {
          await navigator.clipboard.writeText(code);
        } catch (error) {
          // Fallback for browsers without the async clipboard API.
          const field = document.createElement('textarea');
          field.value = code;
          field.setAttribute('readonly', '');
          field.style.position = 'absolute';
          field.style.left = '-9999px';
          document.body.appendChild(field);
          field.select();
          document.execCommand('copy');
          field.remove();
        }

        this.classList.add('is-copied');
        this.label.hidden = true;
        this.done.hidden = false;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.classList.remove('is-copied');
          this.label.hidden = false;
          this.done.hidden = true;
        }, 2000);
      }
    }
  );
}
